import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NotificationProvider} from '../../models/notificationProvider';
import {User} from '../../models/user';
import {AuthService} from '../../services/auth.service';
import {CommonService} from '../../services/common.service';
import {FileService} from '../../services/file.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
    selector: 'app-initialize-form',
    templateUrl: './initialize-form.component.html',
    styleUrls: ['./initialize-form.component.scss']
})
export class InitializeFormComponent implements OnInit {
    imageSource: any;
    user: any;
    pageTitle: any;
    currentUser: User;
    notificationProviders: NotificationProvider[];
    isUserInfoLoading: boolean;
    isProvidersLoading: boolean;
    contactInfo: any;
    isInfoLoading: boolean;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;
    fourthFormGroup: FormGroup;
    fifthFormGroup: FormGroup;
    requestedCode: boolean;
    requestedMobileCode = false;
    loginProvider: string;
    requestLoading: boolean;

    constructor(private formBuilder: FormBuilder, private authService: AuthService,
                private localStorageService: LocalStorageService, public commonService: CommonService,
                public router: Router, public toastMessagesService: ToastMessagesService, public fileService: FileService) {
        this.user = JSON.parse(this.localStorageService.get('user'));
        this.pageTitle = 'Διαμόρφωση στοιχείων χρήστη';
        this.isUserInfoLoading = true;
        this.isInfoLoading = true;
        this.isProvidersLoading = true;
        this.requestedCode = false;
        this.requestLoading = false;
    }

    async ngOnInit() {
        const providerRequest = await this.commonService.getList('common/loginProvider');
        this.loginProvider = 'ldap'; // providerRequest.object;

        this.firstFormGroup = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required]
        });
        this.secondFormGroup = this.formBuilder.group({
            selectedEmail: ['', [Validators.email, Validators.required]],
            otpCode: ['', Validators.required],
            confirmedCode: ['', Validators.required]
        });
        this.thirdFormGroup = this.formBuilder.group({
            mobile: ['', Validators.required],
            otpCode: ['', Validators.required],
            confirmedCode: ['', Validators.required]

        });
        this.fourthFormGroup = this.formBuilder.group({
            tempPassword: ['', Validators.required],
            password: ['', Validators.required],
            confirmPassword: ['', Validators.required],
        });
        this.fifthFormGroup = this.formBuilder.group({
            provider: ['', Validators.required],
        });
        await this.getLogo();
        await this.getContactInfo();
        await this.getParentInfo();
        this.firstFormGroup.controls.firstName.setValue(this.currentUser.first_name);
        this.firstFormGroup.controls.lastName.setValue(this.currentUser.last_name);
        this.thirdFormGroup.controls.mobile.setValue(this.currentUser.telephone);

        await this.getNotificationProviders();
    }

    async getContactInfo() {
        try {
            const contactRequest = await this.commonService.getList(`common/contact`);
            this.contactInfo = contactRequest.object[0];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isInfoLoading = false;
        }
    }

    async getLogo() {
        try {
            const res = await this.fileService.downloadFile(`college/logo`);
            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
                this.imageSource = reader.result;
            };
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.imageSource = '';
        }
    }

    async getParentInfo() {
        try {
            const userInfoRequest = await this.commonService.getList(`people/parent`);
            this.currentUser = userInfoRequest.object[0] as User;
            this.currentUser.declaredEmails = [];
            this.currentUser.declaredEmails = this.currentUser.declared_emails ?  this.currentUser.declared_emails.split(';') : [];
            if (this.currentUser.email) {
                this.currentUser.declaredEmails.push(this.currentUser.email);
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isUserInfoLoading = false;
        }
    }

    async getNotificationProviders() {
        try {
            const providersRequest = await this.commonService.getList(`common/notification_providers`);
            this.notificationProviders = providersRequest.object as NotificationProvider[];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isProvidersLoading = false;
        }
    }

    async requestCode() {
        try {
            console.log(this.secondFormGroup.controls.selectedEmail.value);
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/generateEmailOtp',
                {email: this.secondFormGroup.controls.selectedEmail.value});
            this.requestedCode = true;
            this.toastMessagesService.toastMessages(result.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.requestLoading = false;
        }
    }

    async verifyCode() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/validateEmailOtp',
                {code: this.secondFormGroup.controls.otpCode.value});
            if (result.status === 200) {
                this.secondFormGroup.controls.confirmedCode.setValue(true);
            } else {
                this.toastMessagesService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
            }
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.toastMessagesService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
        } finally {
            this.requestLoading = false;
        }
    }

    passwordsInvalid() {
        return !(this.fourthFormGroup.controls.tempPassword.value &&
            (this.fourthFormGroup.controls.password.value === this.fourthFormGroup.controls.confirmPassword.value));
    }

    resendCode() {

    }

    async requestMobileCode() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/generateMobileOtp',
                {phone: this.thirdFormGroup.controls.mobile.value});
            this.requestedMobileCode = true;
            this.toastMessagesService.toastMessages(result.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.requestLoading = false;
        }
    }

    async verifyMobileCode() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/validateMobileOtp',
                {code: this.thirdFormGroup.controls.otpCode.value});
            if (result.status === 200) {
                this.thirdFormGroup.controls.confirmedCode.setValue(true);
            } else {
                this.toastMessagesService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
        } finally {
            this.requestLoading = false;
        }
    }

    async validateTempPassword() {
        try {
            const result: any = await this.commonService.insertItem('account/validateTempPassword',
                this.fourthFormGroup.controls.tempPassword.value);
            if (result.status === 200) {
            } else {
                this.fourthFormGroup.controls.tempPassword.setValue('');
            }
        } catch (e) {
            this.toastMessagesService.toastMessages('O κωδικός σας δεν είναι σωστός');
            this.fourthFormGroup.controls.tempPassword.setValue('');
        }
    }

    async submitUser() {
        const email = this.secondFormGroup.controls.selectedEmail.value;
        const password = this.fourthFormGroup.controls.password.value;
        const provider = this.fifthFormGroup.controls.provider.value;
        const telephone = this.thirdFormGroup.controls.mobile.value;
        const model = {
            email,
            password,
            telephone,
            provider
        };
        console.log(model);
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.updateItem('account/updateUserRegistration', model);
            if (result.status === 200) {
                this.authService.logOut();
                await this.router.navigate(['/login']);
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.requestLoading = false;
        }
    }

    userHasEmail() {
        if (this.isUserInfoLoading) {
            return false;
        } else {
            return  this.currentUser.declared_emails && this.currentUser.declaredEmails.length > 0;
        }
    }
}
